import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { CurrentPlanCard } from './components/current-plan-card';
import { MigrationModalActionButton } from './components/migration-modal-action-button';
import { PromotionalOfferPlanCard } from './components/promotional-offer-plan-card';
import { modalMessages } from './messages';
import style from './migration-plan-modal.module.less';
import { ModalPortal } from '../../../../../components/modal-portal';

/** @typedef {import('./types.d.ts').PlanDetails} PlanDetails */

/**
 * @param {object} props
 * @param {PlanDetails} props.currentPlanDetails
 * @param {boolean} props.isActionDisabled
 * @param {() => void} props.onAction
 * @param {() => void} props.onClose
 * @param {PlanDetails} props.promotionalPlanDetails
 * @returns {JSX.Element}
 */
export const MigratePlanModal = ({ currentPlanDetails, isActionDisabled, onAction, onClose, promotionalPlanDetails }) => (
  <ModalPortal onCancel={onClose} onClose={onClose}>
    <Modal className={style['migration-modal']} size='custom'>
      <ModalHeader>
        <Text textType={TextType.H3} value={modalMessages.headerMessage} />
      </ModalHeader>
      <ModalBody className={style['migration-modal-body']}>
        <FlexColumn className={style['migration-modal-content']}>
          <CurrentPlanCard planDetails={currentPlanDetails} />
          <PromotionalOfferPlanCard planDetails={promotionalPlanDetails} />
          <Text className={style['offer-details']} textType={TextType.Caption} value={modalMessages.finePrint} />
        </FlexColumn>
      </ModalBody>
      <ModalFooter className={style.footer}>
        <Button onClick={onClose} theme={THEME_CONSTANTS.white}>
          <FormattedMessage {...modalMessages.cancelButton} />
        </Button>
        <MigrationModalActionButton isActionDisabled={isActionDisabled} onAction={onAction} />
      </ModalFooter>
    </Modal>
  </ModalPortal>
);
